import { AppStateWithData } from "../../redux/AppStateWithData"

export const getToken = (state: AppStateWithData): string => {
    const token = state.data.auth.token
    if (!token) {
        const errorObject = {
            message: "Can't find user token",
            errorObject: {}
        }
        throw errorObject
    }

    return token
}